@import '../../globals/variables';
/**
 * THEME JSON CONFIG CSS VARS
 * The following default component scss variables can be overwritten via theme configuration per brand.
 * If you need to add new one, please make sure to set a default value.
 * JSON Definition for Component with name "Example": testCssVar: "20px"
 * Resulting CSS var: $example-test-css-var: 20px;
 */

$preloader-squares-wrapper-width: 88px !default;
$preloader-squares-wrapper-height: 22px !default;
$preloader-squares-item-width: 14px !default;
$preloader-squares-item-height: 14px !default;
$preloader-squares-default-radius: 100% !default;

/* END THEME JSON CONFIG CSS VARS ******************************************************* */

$animDuration: 1.5s;
$delay: 100ms;
$decay: 1.4;

:host {
  display: inline-block;
}

.#{$prefix}preloader-wrapper {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: auto;

  .#{$prefix}preloader-svg {
    position: relative;
    height: 16px;
    line-height: 16px;

    .#{$prefix}preloader-shape {
      animation-duration: $animDuration;
      animation-iteration-count: infinite;
      animation-timing-function: cubic-bezier(0.33, 0, 0.35, 1);
      animation-name: fade-in;
      fill: v(backgroundColor);

      &.#{$prefix}preloader-shape-2 {
        animation-delay: $delay;
      }

      &.#{$prefix}preloader-shape-3 {
        animation-delay: $delay * 2;
      }

      &.#{$prefix}preloader-shape-4 {
        animation-delay: $delay * 3;
      }
    }

    @keyframes fade-in {
      0% {
        opacity: 0;
      }

      30% {
        opacity: 0;
      }

      40% {
        opacity: 1;
      }

      60% {
        opacity: 1;
      }

      100% {
        opacity: 0;
      }
    }
  }

  .#{$prefix}preloader-text {
    color: v(color);
    font-family: $font-family-base;
    font-size: 18px;
    font-weight: 400;
    line-height: 24px;
    margin-top: 18px;
  }
}

/*!
 * Load Awesome v1.1.0 (http://github.danielcardoso.net/load-awesome/)
 * Copyright 2015 Daniel Cardoso <@DanielCardoso>
 * Licensed under MIT
 */
.#{$prefix}preloader-squares,
.#{$prefix}preloader-squares > div {
  position: relative;
  box-sizing: border-box;
}

.#{$prefix}preloader-squares {
  display: block;
  font-size: 0;
  color: v(backgroundColor);
}

.#{$prefix}preloader-squares > div {
  display: inline-block;
  float: none;
  background-color: currentColor;
  border: 0 solid currentColor;
}

.#{$prefix}preloader-squares {
  width: $preloader-squares-wrapper-width;
  height: $preloader-squares-wrapper-height;
}

.#{$prefix}preloader-squares > div:nth-child(1) {
  animation-delay: -600ms;
}

.#{$prefix}preloader-squares > div:nth-child(2) {
  animation-delay: -400ms;
}

.#{$prefix}preloader-squares > div:nth-child(3) {
  animation-delay: -200ms;
}

.#{$prefix}preloader-squares > div:nth-child(4) {
  animation-delay: 0ms;
}

.#{$prefix}preloader-squares > div {
  width: $preloader-squares-item-width;
  height: $preloader-squares-item-height;
  margin: 4px;
  border-radius: $preloader-squares-default-radius;

  //animation: ball-pulse 1s ease infinite;
  animation: fade-in 1s ease infinite;
}

/*
 * Animation
 */

//@keyframes ball-pulse {
//  0%,
//  60%,
//  100% {
//    opacity: 1;
//    transform: scale(1);
//  }
//  30% {
//    opacity: 0.1;
//    transform: scale(0.01);
//  }
//}
